import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import NewsTableSkeleton from "./NewsTableSkeleton.js";
import { useTheme } from "../Theme/ThemeContext";

const PendingNews = ({ handleViewDetails }) => {
  const [pendingNews, setPendingNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();

  useEffect(() => {
    fetchPendingNews();
  }, []);

  const fetchPendingNews = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("/api/news/pending", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const sortedNews = response.data.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setPendingNews(sortedNews);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching pending news:", error);
    }
  };

  const handleApproveNews = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.patch(
        `/api/news/approve/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const updatedPendingNews = pendingNews.filter(
        (article) => article._id !== id
      );
      setPendingNews(updatedPendingNews);
      fetchPendingNews();
    } catch (error) {
      console.error("Error approving news:", error);
    }
  };

  const handleDeleteNews = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this news article?");
    if (!confirmed) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/api/news/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const updatedPendingNews = pendingNews.filter(
        (article) => article._id !== id
      );
      setPendingNews(updatedPendingNews);
    } catch (error) {
      console.error("Error deleting news:", error);
    }
  };

  return (
    <div>
      <h2>Pending News</h2>
      {loading ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Article Details</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <NewsTableSkeleton />
            <NewsTableSkeleton />
            <NewsTableSkeleton />
          </tbody>
        </Table>
      ) : (
        <Table striped bordered hover className={theme === "dark" ? "table-dark" : ""}>
          <thead>
            <tr>
              <th>Article details</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendingNews.map((article) => (
              <tr key={article._id}>
                <td onClick={() => handleViewDetails(article)}>
                  <h5>{article.title}</h5>
                  <p>{article.city}, {article.state}</p>
                  <p>{moment(article.date).subtract(5, 'hours').subtract(30, 'minutes').format("DD-MM-YYYY, h:mm A")}</p>
                  {article.reporter.username}
                </td>
                <td style={{ width: '10%' }}>
                  <Button
                    className="mt-2 me-2"
                    variant="success"
                    onClick={() => handleApproveNews(article._id)}
                  >
                    Approve
                  </Button>{" "}
                  <Button
                    className="mt-2 me-2"
                    variant="danger"
                    onClick={() => handleDeleteNews(article._id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default PendingNews;
